export default __webpack_public_path__ + "c7c1503f4eed6801464f61428a6a0fd5.svg";